export default "__VITE_ASSET__iYbHrGYc__"